module.exports = __webpack_public_path__ + "img/icon_weather_104.d2473430.svg";